import { Check, LoaderCircleIcon } from 'lucide-react';
import {
  Stepper,
  StepperIndicator,
  StepperItem,
  StepperNav,
  StepperSeparator,
  StepperTitle,
  StepperTrigger,
} from '@/components/shadcn/Stepper';
import { cn } from '@/utils/style';

export interface Step {
  title: string;
}

interface StepsProps {
  steps: Step[];
  currentStep: number;
  hideProgress?: boolean;
  className?: string;
  stepsClassName?: string;
}

export default function Steps(props: StepsProps) {
  const { steps, currentStep, hideProgress, className, stepsClassName } = props;

  return (
    <Stepper
      value={currentStep}
      indicators={{
        completed: <Check className="size-4" />,
        loading: <LoaderCircleIcon className="size-4 animate-spin" />,
      }}
      className={className}
    >
      <div className={cn('px-[10%]', stepsClassName)}>
        {!hideProgress && (
          <StepperNav>
            {steps.map((step, index) => (
              <StepperItem key={step.title} step={index} className="relative ">
                <StepperTrigger className="flex justify-start gap-1.5 cursor-auto">
                  <StepperIndicator>{index + 1}</StepperIndicator>
                  <StepperTitle className="text-center">{step.title}</StepperTitle>
                </StepperTrigger>

                {steps.length > index + 1 && (
                  <StepperSeparator className="md:mx-2.5 group-data-[state=completed]/step:bg-primary" />
                )}
              </StepperItem>
            ))}
          </StepperNav>
        )}
      </div>
    </Stepper>
  );
}
